/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const _empty = /* GraphQL */ `
  query _empty {
    _empty
  }
`;
export const getDmsTrucks = /* GraphQL */ `
  query GetDmsTrucks($selectedDate: AWSDate!, $IDWarehouse: ID!) {
    getDmsTrucks(selectedDate: $selectedDate, IDWarehouse: $IDWarehouse) {
      ID
      Control
      IDTruckVendor
      ScheduledPOs
      UnScheduledPOs
      PO
      POStatus
      Dock
      IDDock
      Door
      Carrier
      Vendor
      IDWarehouseCarrier
      ScheduledTime
      ArrivalTime
      CheckInTime
      InDoorTime
      LumpStartTime
      LumpEndTime
      BillsInTime
      BillsOutTime
      OutDoorTime
      CheckOutTime
      BatchStartDatetime
      TruckLoadStatus
      TruckCount
      DriverUnload
      Backhaul
      Dropped
      Acknowledged
      IDBatch
      IDWarehouse
      IsActiveTruckBatch
      IDVendorCommodity
      CreatedOn
      UpdatedOn
      operationType
      underOneHour
      overOneHour
      overOnePointFiveHour
      TruckSequence
      Notes
    }
  }
`;
export const getDmsBuckets = /* GraphQL */ `
  query GetDmsBuckets($IDWarehouse: ID!, $selectedDate: AWSDate!) {
    getDmsBuckets(IDWarehouse: $IDWarehouse, selectedDate: $selectedDate) {
      ID
      WarehouseID
      WarehouseName
      StartDate
      EndDate
      StartTime
      EndTime
      Status
      count {
        over_1_5_hr
        over_1_hr
        under_1_hr
      }
    }
  }
`;
export const getSPRODownloadReport = /* GraphQL */ `
  query GetSPRODownloadReport($ID: ID!) {
    getSPRODownloadReport(ID: $ID) {
      ID
      CUID
      IDWarehouse
      ReportType
      StartDate
      EndDate
      Type
      ReportEmail
      Status
      CreatedOn
      CreatedBy
      URL
    }
  }
`;
export const listSPRODownloadReports = /* GraphQL */ `
  query ListSPRODownloadReports($CUID: ID, $IDWarehouse: ID, $Status: Boolean) {
    listSPRODownloadReports(
      CUID: $CUID
      IDWarehouse: $IDWarehouse
      Status: $Status
    ) {
      ID
      CUID
      IDWarehouse
      ReportType
      StartDate
      EndDate
      Type
      ReportEmail
      Status
      CreatedOn
      CreatedBy
      URL
    }
  }
`;
export const getReleaseBanners = /* GraphQL */ `
  query GetReleaseBanners {
    getReleaseBanners {
      id
      service
      prevVersion
      currentVersion
      isReleaseDone
      isActive
      isDeleted
      forceUpdate
      bannerHeading
      bannerText
      bannerSubtext
      bannerLogo
      bannerDisclaimer
      releaseDate
      notificationType
      startDateTime
      endDateTime
      severity
    }
  }
`;
export const getReleaseBannerById = /* GraphQL */ `
  query GetReleaseBannerById($id: String!) {
    getReleaseBannerById(id: $id) {
      id
      service
      prevVersion
      currentVersion
      isReleaseDone
      isActive
      isDeleted
      forceUpdate
      bannerHeading
      bannerText
      bannerSubtext
      bannerLogo
      bannerDisclaimer
      releaseDate
      notificationType
      startDateTime
      endDateTime
      severity
    }
  }
`;
